import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit';
import { ModalLayout } from './parts/ModalLayout';
import { ModalHeader } from './parts/ModalHeader';
import { CallButton } from './parts/CallButton';
import { ModalContent } from './parts/ModalContent';
import { Heading } from './parts/Heading';
import { LayoutImage } from './parts/LayoutImage';
import { FlatsSlider } from './parts/FlatsSlider';
import { SliderContext } from './parts/Scroller/utils/sliderContext';
import { useSliderContextBuilder } from './parts/Scroller/utils/useSliderContextBuilder';
import { ExcursionBlock } from './parts/ExcursionBlock';
import { Loading } from './parts/Loading';
import { ErrorScreen } from './parts/ErrorScreen';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var LayoutModal = function LayoutModal(_ref) {
  var onClose = _ref.onClose,
    onReset = _ref.onReset,
    trackAdditionalCardClick = _ref.trackAdditionalCardClick,
    trackTourClick = _ref.trackTourClick,
    open = _ref.open,
    callButton = _ref.callButton,
    layoutImageUrl = _ref.layoutImageUrl,
    layoutOffers = _ref.layoutOffers,
    isLoading = _ref.isLoading;
  var sliderContext = useSliderContextBuilder();
  return /*#__PURE__*/_jsx(ModalFullscreen, {
    onClose: onClose,
    open: open,
    theme: "white",
    children: /*#__PURE__*/_jsxs(ModalLayout, {
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        onClose: onClose
      }), !isLoading && layoutOffers && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(ModalContent, {
          children: [/*#__PURE__*/_jsx(Heading, {
            title: layoutOffers.title,
            description: layoutOffers.offersDescription,
            url: layoutOffers.offersDescriptionUrl
          }), /*#__PURE__*/_jsx(LayoutImage, {
            url: layoutImageUrl
          }), /*#__PURE__*/_jsx(ExcursionBlock, {
            tourUrl: layoutOffers.tourUrl,
            onOpen: trackTourClick
          })]
        }), /*#__PURE__*/_jsx(SliderContext.Provider, {
          value: sliderContext,
          children: /*#__PURE__*/_jsx(FlatsSlider, {
            flats: layoutOffers.offers,
            offersUrl: layoutOffers.offersDescriptionUrl,
            offersCount: layoutOffers.offersCount,
            trackAdditionalCardClick: trackAdditionalCardClick
          })
        }), /*#__PURE__*/_jsx(CallButton, {
          children: callButton
        })]
      }), isLoading && /*#__PURE__*/_jsx(Loading, {}), !isLoading && !layoutOffers && /*#__PURE__*/_jsx(ErrorScreen, {
        onReset: onReset
      })]
    })
  });
};